import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { isNull, isArray, concat, trim, isUndefined } from 'lodash';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  Select,
} from '~/components/Form';

import { GFO } from '~/constants/perfil';

import { toast } from 'react-toastify';
import * as Yup from 'yup';
import qs from 'querystring';
import api from '~/services/api';
import { parseDateString, t } from '~/helpers';

function Reldespesaaquisicaocombustivelorgao() {
  const [open, setOpen] = useState(true);

  const [valueOrgao, setValueOrgao] = useState('');
  const [valueProduto, setValueProduto] = useState('');

  const [organ, setOrgan] = useState({ orga_codigo: '', orga_nome: '' });
  const [organDisable, setOrganDisable] = useState(false)

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);





  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        orgao:organDisable ? Yup.string() : Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  const handleValidOrgaos = useCallback(async () => {

    try {

      const { data } = await api.get('orgaos');

      if (data.items.length == 1) {
        let tempOrgan = data.items[0]
        setOrgan(tempOrgan)
        setOrganDisable(true)

      } else if (data.items.length == 0) {
        setOrgan({ orga_codigo: '', orga_nome: '' })
        setOrganDisable(true)
      } else {
        setOrganDisable(false)
      }

    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }

  }, [])

  const handleChangeOrgan = useCallback((value) => {
    if (isNull(value.orga_nome)) setOrgan({ orga_codigo: '', orga_nome: '' });
    else {
      setOrgan(value);
    }
  }, []);

  useEffect(() => {
    handleValidOrgaos()
  }, [])



  const onSerializeData = useCallback((data) => ({
    ...data,
    orgao: organ.orga_codigo,
    orgaostr: organ.orga_nome,
    combustivel: valueProduto.prod_codigo ? valueProduto.prod_codigo : '',
    combustivelstr: valueProduto.prod_descricao ? valueProduto.prod_descricao : '',
    produto: valueProduto.prod_codigo ? valueProduto.prod_codigo : '',
    produtostr: valueProduto.prod_descricao ? valueProduto.prod_descricao : ''
  }))
  
  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Despesa com Aquisição de Combustível - Órgão"
      relatorio="DESPESAAQUISICAOCOMBUSTIVELORGAO"
      validate={(param) => handleValidate(param)}
      serialize={onSerializeData}
      initials={{
        datahorainicial,
        datahorafinal,
      }}
    >
      {/* <DateTime time label="Data Inicial" disableFuture name="datahorainicial" />
      <DateTime time label="Data Final" disableFuture name="datahorafinal" /> */}
      <DateTime
        time
        disableFuture
        label="Data Inicial"
        name="datahorainicial"
      />

      <DateTime
        time
        disableFuture
        label="Data Final"
        name="datahorafinal"
        maxDateMessage=""
      />


      <Autocomplete
        includeInputInList
        disabledItemsFocusable
        disableClearable={!organ.orga_nome}
        name="orgao"
        label="orga_nome"
        title="Órgão"
        url="orgaos"
        unique="orga_codigo"
        inputValue={organ.orga_nome}
        disabled={organDisable}
        getValue={handleChangeOrgan}
        onInputChange={(event, value) => {
          let obj = {
            ...organ,
            orga_nome: value,
          }
          setOrgan(obj);
        }}
      />

      <Autocomplete
        name="produto"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => setValueProduto(value)}
      />

      <RadioGroup
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Reldespesaaquisicaocombustivelorgao;
